<div class="date-input-row">
  <div class="date-field-wrapper" [class.disabled]="isDisabled">
    <ng-container *ngFor="let seg of segments; let i = index; let last = last">
      <input
        #segInput
        type="tel"
        class="date-segment"
        [class.date-segment-year]="seg.type === 'year'"
        [attr.maxlength]="seg.maxLen"
        [attr.aria-label]="seg.ariaLabel"
        [placeholder]="seg.placeholder"
        [value]="segmentValues[seg.type]"
        [disabled]="isDisabled"
        (focus)="onSegmentFocus($event)"
        (input)="onSegmentInput($event, i)"
        (keydown)="onSegmentKeydown($event, i)"
        (blur)="onSegmentBlur(i)">
      <span class="date-sep" *ngIf="!last">{{ separator }}</span>
    </ng-container>
  </div>
  <ion-button fill="clear" class="dob-calendar-button" [disabled]="isDisabled" aria-label="Open date picker" (click)="openDobPicker()">
    <ion-icon name="calendar-outline"></ion-icon>
  </ion-button>
</div>
<p class="dob-verbose" *ngIf="isDateValid">{{ verboseDate }}</p>
<ion-modal #pickerModal [keepContentsMounted]="true" [backdropDismiss]="false" style="--width: auto; --height: auto; --border-radius: 12px; --min-height: unset;">
  <ng-template>
    <ion-datetime
      #pickerDatetime
      mode="ios"
      presentation="date"
      preferWheel="true"
      [locale]="locale"
      [min]="minDate"
      [max]="maxDate"
      (ionChange)="onPickerChange($event)">
      <ion-buttons slot="buttons">
        <ion-button color="medium" (click)="cancelPicker()">Cancel</ion-button>
        <ion-button fill="solid" color="primary" class="dob-set-button" (click)="confirmPicker()">Set</ion-button>
      </ion-buttons>
    </ion-datetime>
  </ng-template>
</ion-modal>
